import { Box } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useStore } from '@roc/client-portal-shared/hooks';
import { DocReviewSection } from '../../docReviewSection';
import { HudFundingTemplateTable } from './hudFundingTemplateTable';

export const HudFundingTemplateSection = observer(({ data }: { data: Record<string, any> }) => {
  const { globalStore } = useStore();
  const items = data?.fundingTemplate;
  if (!globalStore.isInternalPortal || !Array.isArray(items) || items.length === 0) {
    return null;
  }
  return (
    <Box mt={2}>
      <DocReviewSection title="Funding Template">
        <HudFundingTemplateTable items={items} />
      </DocReviewSection>
    </Box>
  );
});
